import { ResponsiveLine } from '@nivo/line';
import { getLatestArchiveData } from '../helpers/Utils';
import { React, useEffect, useState } from 'react';

const TempGraph = ({limit, params, lang}) => {
    const [jsondata, setJsonData] = useState([]);
    useEffect(() =>{
        const fetchJson = async () => {
            const data = await getLatestArchiveData(limit, params, lang);
            setJsonData(data);
            //console.log("getLatestArchiveData:"+params+JSON.stringify(data));
        }
        fetchJson();
    }, [])

    const MyCustomTooltip = ({ point }) => {
        console.log('MyCustomTooltip ', point);
      // You can access point.data, point.serieId, etc.
      // Implement your custom positioning logic here using CSS
      return (
        <div style={{
          position: 'absolute',
          background: 'white',
          padding: '8px',
          border: '1px solid #ccc',
          zIndex: 100, // Ensure it's above other elements
        }}>
          {/* Your tooltip content */}
          
        </div>
      );
    };

    return (
        <ResponsiveLine
        animate
        data={jsondata}
        curve="linear"
        colors={{ scheme: 'dark2' }}
        margin={{ top: 40, right: 40, bottom: 40, left: 60 }}
        theme={{
        background: '#ffffff', // Set your desired background color here
        // Other theme properties...
        }}
        xScale={{ 
            format: '%Y-%m-%d %H:%M:%S',
            precision: 'minute',
            type: 'time',
            useUTC: false}}
        yScale={{
            type: 'linear',
            min: 'auto',
            max: 'auto',
            stacked: false,
            reverse: false
        }}
        yFormat=" >-.1f"
        xFormat="time:%Y-%m-%d %H:%M:%S"
        axisBottom={{
            ticks:20,
            format: ' %H:%M',
            tickValues: 'every 60 minutes',
            tickSize: 1,
            tickPadding: 5,
            tickRotation: 90,
            legend: 'זמן',
            legendOffset: 12,
            legendPosition: 'middle'
        }}
        
        axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'טמפרטורה',
            legendOffset: -40,
            legendPosition: 'middle'
        }}
        pointSize={1}
         pointColor={{ from: 'color', modifiers: [] }}
        pointBorderColor={{ from: 'serieColor' }}
        enableGridX={false}
        enableGridY={false}
        enableSlices="x"
         sliceTooltip={({ slice }) => {
      // Fetch the formatted date from the first point in the slice
      const formattedDate = slice.points[0]?.data.xFormatted;
      let title =slice.points[0]?.id;
      return (
        <div style={{ background: 'white', color: 'black', padding: '10px', width: '200px', border: '1px solid #ccc', textAlign: 'start' }}>
          {/* Display the human-readable date */}
          <div><strong>{formattedDate}</strong></div>
          
          {slice.points.map(point => (
            
            <div key={point.id} style={{ color: point.seriesColor, margin: '4px 0' }}>
              <span>{point.seriesId} </span>
              <strong>{point.data.yFormatted}</strong>
            </div>
          ))}
        </div>
      );
    }}
        enableTouchCrosshair={true}
        useMesh={true}
        height={400}
        legends={[
            {
                anchor: 'top',
                direction: 'column',
                justify: true,
                translateX: 0,
                translateY: -20,
                itemsSpacing: 0,
                itemDirection: 'left-to-right',
                itemWidth: 40,
                itemHeight: 20,
                itemOpacity: 0.75,
                symbolSize: 11,
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
    />
    );
}

export default TempGraph;
